module.exports = "/img/city-zurich.b26bae94.jpg";